/**
 * Autocomplete para um input do tipo select.
 *
 * O campo select é criado sem dados, é solicitado que o usuario digite o nome do cliente,
 * conforme ele vai digitando os clientes que correspondão ao valor digitaldo vão sendo
 * retornados.
 */
(function () {
    const select2AutoCompleteCliente = $('#select2-autocomplete-cliente');
    if (select2AutoCompleteCliente.length === 0) {
        return;
    }

    const urlBusca = `${window.location.protocol}//${window.location.host}/clientes/json`;
    select2AutoCompleteCliente.select2({
        language: 'pt-BR',
        minimumInputLength: 3,
        ajax: {
            url     :  urlBusca,
            delay   : 250,
            dataType: 'json',
            cache   : true,
            data    : function (params) {
                return {
                    'campos[cliente]': 'id,nome as text',
                    'nome'           : params.term,
                    'status'         : 1,
                };
            },
            processResults: function (data) {
                return {
                    results: data
                };
            },
        }
    });
})();
